module.exports = __webpack_public_path__ + "static/media/Maxim Kapelina - Resume 2026.3ddaae52.pdf";